'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

var _transaction = require('./transaction');

var _transaction2 = _interopRequireDefault(_transaction);

/******************************************************************************
 * The Query injector is a a convenience method designed to handle query
 * transactions and inject the result as properties on the original
 * component.
 *
 * Injecting results as properties gives us the most flexibility as the
 * component itself doesn't need to care about where data comes from. We
 * could remove the injection of one component, fetch the data further up
 * the hierarchy and simply pass it down without any alterations to the
 * component logic.
 *
 * Usage:
 *
 *	@Query.inject(props => {
 * 		return {
 * 			avatar : Query.run('GetUserAvatar', props.userId)
 * 		};
 * 	})
 * 	class UserAvatar extends React.Component {
 * 		render () {
 * 			let avatar = this.props.avatar.value;
 * 			let src    = avatar ? avatar.src : SOME_DEFAULT_IMAGE;
 *
 * 			return (<div className="user-avatar">
 * 				<img src={src} />
 * 			</div>);
 * 		}
 * 	}
 *
 * As you can see above we could easily strip the injection in this
 * component and move it elsewhere and as long as we pass in the
 * avatar property we do not have to alter anything else.
 */

exports['default'] = function (Component, RunQueries) {
	return (function (_React$Component) {
		_inherits(QueryInjector, _React$Component);

		_createClass(QueryInjector, null, [{
			key: 'contextTypes',
			get: function get() {
				return {
					$QUERY_SESSION: _react2['default'].PropTypes.instanceOf(_session2['default'])
				};
			}
		}]);

		function QueryInjector() {
			_classCallCheck(this, QueryInjector);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			_get(Object.getPrototypeOf(QueryInjector.prototype), 'constructor', this).apply(this, args);

			this.state = {};
			this.transactions = {};
			this.listeners = {};

			this.runQueries(this.props);
		}

		_createClass(QueryInjector, [{
			key: 'runQueries',
			value: function runQueries(props) {
				var _this = this;

				var session = this.context.$QUERY_SESSION || _session2['default'].Current;

				_session2['default'].bind(session, function () {
					var txs = RunQueries(props);

					Object.keys(txs).forEach(function (key) {
						var tx = txs[key];

						_this.state[key] = tx.result;
						_this.transactions[key] = tx;
					});
				});
			}
		}, {
			key: 'bindTransactions',
			value: function bindTransactions() {
				var _this2 = this;

				Object.keys(this.transactions).forEach(function (key) {
					var tx = _this2.transactions[key];
					if (!tx.complete) {
						var listener = _this2.listeners[key] = function () {
							_this2.onTransactionComplete(key, tx);
						};
						tx.observe(listener);
						if (tx.mode === _transaction2['default'].Mode.NON_BLOCKING) {
							tx.resume();
						}
					}
				});
			}
		}, {
			key: 'clearTransactions',
			value: function clearTransactions() {
				var _this3 = this;

				Object.keys(this.listeners).forEach(function (key) {
					var tx = _this3.transactions[key];
					if (tx) {
						tx.unobserve(_this3.listeners[key]);
						delete _this3.listeners[key];
					}
				});
			}
		}, {
			key: 'onTransactionComplete',
			value: function onTransactionComplete(name, tx) {
				this.setState(_defineProperty({}, name, tx.result));
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this4 = this;

				var didChange = false;
				Object.keys(this.props).forEach(function (key) {
					if (nextProps[key] !== _this4.props[key]) {
						didChange = true;
					}
				});

				if (didChange) {
					this.clearTransactions();
					this.runQueries(nextProps);
					this.bindTransactions();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.bindTransactions();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.clearTransactions();
			}
		}, {
			key: 'render',
			value: function render() {
				var props = Object.assign({}, this.props, this.state);

				return _react2['default'].createElement(Component, props);
			}
		}]);

		return QueryInjector;
	})(_react2['default'].Component);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/injector.js
// module id = qOvj
// module chunks = 15